export class AccountData {

  id;

  username;

  password;

  profiles;

  static objectDuplicate = (accountData) => {
    let target = new AccountData();
    Object.assign(target, accountData);
    return target;
  }

  static newLoginData = (username, password) => {
    let result = new AccountData();
    result.username = username;
    result.password = password;
    return result;
  }

}


export class profile {

  id;

  profile;

}
